import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { API } from "../../../API";
import { isAutheticated } from "../../auth/authhelper";
import { Link } from "react-router-dom";


const ApplicationNamePage = () => {
    const token = isAutheticated()

    const [appName, setAppName] = useState("");
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");

    // Fetch Application Name from API
    const fetchAppName = async () => {
        setLoading(true);
        setError("");
        try {
            const response = await axios.get(`${API}/api/config`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })

            response?.data?.result.map((item) => {
                setAppName(item?.appName || "")

            })
        } catch (err) {
            setError("Failed to load application name. Please try again.");
        } finally {
            setLoading(false);
        }
    };


    // Save or Update Application Name through API
    const handleSave = async () => {
        setSaving(true);
        setError("");
        try {
            const response = await axios.post(`${API}/api/config/application/name`, { appName }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }); // Replace with actual API endpoint
            setSaving(false);

            alert("Application Name Saved");
        } catch (err) {
            setError("Failed to save application name. Please try again.");
        } finally {
            setSaving(false);
        }
    };

    // Fetch data on component mount
    useEffect(() => {
        fetchAppName();
    }, []);

    return (
        <div className="main-content bg-light py-4">
            <div className="page-content">
                <div className="container-fluid">
                    <div className='col-12'>
                        <div className='page-title-box d-flex align-items-center justify-content-between'>
                            <h4 className='mb-0'>Business - Name</h4>

                            <div className='page-title-right'>
                                <ol className='breadcrumb m-0'>
                                    <li className='breadcrumb-item'>
                                        <Link to='/dashboard'>SoComOTT</Link>
                                    </li>
                                    <li className='breadcrumb-item'>Business - Name</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <div
                                    className="d-flex justify-content-center align-items-center"
                                    style={{ minHeight: "80vh" }}
                                >
                                    <div
                                        className="card shadow-lg rounded-lg border-0"
                                        style={{ maxWidth: "500px", width: "100%" }}
                                    >
                                        <div className="card-body p-4">
                                            <h2 className="card-title text-center mb-4 text-primary fw-bold">
                                                Update Business Name
                                            </h2>
                                            <p className="text-center text-muted mb-4">
                                                Customize the name of your Business for branding and user recognition.
                                            </p>

                                            {/* Loading Indicator */}
                                            {loading ? (
                                                <div className="text-center py-3">
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    {/* Error Message */}
                                                    {error && (
                                                        <div className="alert alert-danger text-center" role="alert">
                                                            {error}
                                                        </div>
                                                    )}
                                                    {/* Form */}
                                                    <form
                                                        onSubmit={(e) => {
                                                            e.preventDefault();
                                                            handleSave();
                                                        }}
                                                    >
                                                        <div className="mb-4">
                                                            <label htmlFor="appName" className="form-label fw-semibold">
                                                                Business Name
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control shadow-sm rounded"
                                                                id="appName"
                                                                value={appName}
                                                                onChange={(e) => setAppName(e.target.value)}
                                                                placeholder="Enter Business name"
                                                                required
                                                            />
                                                        </div>
                                                        <div className="d-grid">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary shadow-sm rounded py-2"
                                                                disabled={saving}
                                                            >
                                                                {saving ? (
                                                                    <span
                                                                        className="spinner-border spinner-border-sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                    ></span>
                                                                ) : (
                                                                    "Save Business Name"
                                                                )}
                                                            </button>
                                                        </div>
                                                    </form>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApplicationNamePage;
